import React from 'react';

interface IArrowDownIconProps {
  style?: any;
}

export const ArrowDownIcon:React.FC<IArrowDownIconProps> = (props: IArrowDownIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" fill="none" viewBox="0 0 23 22">
        <path fill={props.style?.fillColor ? props.style.fillColor : "#122442"} d="M6.7 7.3l4.6 4.6 4.6-4.6 1.4 1.4-6 6-6-6 1.4-1.4z"/>
    </svg>
  )
}